import './About.css';

const About = () => {

    return (
        <div id="about-container">
            <div id="about-content">
                <h2 id="about-title">About Me</h2>
                <p id="about-text">
                    Hello! I'm Sanjeet Kumar. I’m a graduate of 2022 from Sikkim Manipal Institute of Technology with a degree in Electronics and Communication Engineering. I'm most passionate about giving back to the community, and my goal is to pursue this passion within the field of software engineering. In my free time I like working on open source projects.
                </p>
            </div>
        </div>
    )
}

export default About



